module.exports = __webpack_public_path__ + "img/avatar.19a29360.png";